import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import LanguageSelector from "./translation/LanguageSelector";
//import { useSelector } from "react-redux";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Button,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from '@mui/icons-material/Error';
import { CreateAdminForm } from "./forms/CreateAdminForm";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Logo from "../assets/ekologo.png";
import { useRegisterUser, useUserLoginData } from "../api/ekoApi";
import { transformObject } from "../utils/transformCreateUser";
import { StepperHorizontal } from "./forms/Stepper";
import { useTranslation } from "react-i18next";
import { Close } from "@mui/icons-material";
import { PrivacyPolicyComponent } from "./PrivacyPolicy";

const Layout = () => {
  // const auth = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const { data: loggedUser } = useUserLoginData();
  const { t, i18n } = useTranslation();
  const registerUser = useRegisterUser();
  const [isModalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState(" ");
  const [message, setMessage] = useState('');
  const [isTermsModalOpen, setTermsModalOpen] = useState(false);
  const [ispatientModalOpen, setPatientModalOpen] = useState(false);


  const handleOpenModal = () => {
    setModalOpen(true);
  };
console.log(i18n.language)
  const handlePatientOpenModal = () => {
    setPatientModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleClosePatientModal = () => {
    setPatientModalOpen(false);
  };

  useEffect(() => {
    const hasAcceptedTerms = localStorage.getItem("acceptedTerms");
    if (!hasAcceptedTerms) {
      setTermsModalOpen(true);
    }
  }, []);

  const handleAcceptTerms = () => {
    localStorage.setItem("acceptedTerms", "true");
    setTermsModalOpen(false);
  };

  const handleCreateUser = async (formData) => {
    try {
      const createUserData = transformObject(formData);
    
    // Await the mutation to ensure it completes before proceeding
    await registerUser.mutateAsync(createUserData);
      
      // Assuming the response has a message field
      setMessage('userSuccess');
      setMode('success')
    } catch (error) {
      console.log(error?.response?.data?.message)
      setMode('error')
      setMessage(error?.response?.data?.message || 'An error occurred during registration.');
      return
    }
  };

  function handleLogout() {
    localStorage.removeItem("authData");
    navigate("/login", { replace: true });
  }

  return (
    <div>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "transparent",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={Logo}
              alt="logo from app bar"
              style={{
                maxWidth: "150px",
                height: "auto",
                marginBottom: "10px",
                marginRight: "20px",
              }}
            />
            {loggedUser?.organization && (
              <Chip label={loggedUser?.organization} variant="outlined" />
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            {loggedUser?.role !== "User" ? (
              <IconButton aria-label="admin-create" onClick={handleOpenModal}>
                <Tooltip title={t("createAdmin")}>
                  <PersonAddIcon />
                </Tooltip>
              </IconButton>
            ) : (
              <IconButton
                aria-label="user-create"
                onClick={handlePatientOpenModal}
              >
                <Tooltip title={t("createPatient")}>
                  <PersonAddIcon />
                </Tooltip>
              </IconButton>
            )}

            <Typography
              variant="body1"
              component="div"
              sx={{ color: "black", marginLeft: "10px" }}
            >
              {loggedUser?.displayName}
            </Typography>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              //onClick={handleMenu}
              color="blue"
            >
              <AccountCircle />
            </IconButton>

            <LanguageSelector />

            <Button sx={{ ml: 1 }} onClick={handleLogout}>
              {t("logout")}
            </Button>
          </div>
        </Toolbar>
        <Snackbar
        open={Boolean(message)}
        autoHideDuration={2000}
        onClose={() => setMessage("")}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert icon={ mode === 'success' ? <CheckIcon fontSize="inherit"/> : <ErrorIcon fontSize="inherit" />} severity={mode}>
          {t(message)}
        </Alert>
      </Snackbar>
      </AppBar>

      {/* Render the child components */}
      <main>
        <Outlet />
      </main>

      {/* Modal for creating user */}
      <Dialog open={isModalOpen} onClose={handleCloseModal}>
        <DialogTitle
          sx={{
            backgroundColor: "black",
            color: "white",
            paddingTop: 1,
            paddingBottom: 1,
          }}
        >
          {loggedUser?.role === "SuperAdmin"
            ? t("createAdmin")
            : t("createUser")}
        </DialogTitle>
        <DialogContent sx={{ marginTop: 2 }}>
          <CreateAdminForm
            handleSubmit={handleCreateUser}
            handleCloseModal={handleCloseModal}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={ispatientModalOpen}
        onClose={handleClosePatientModal}
        maxWidth="lg"
      >
        <DialogTitle
          sx={{
            backgroundColor: "black",
            color: "white",
            paddingTop: 1,
            paddingBottom: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {t("createPatient")}
          <IconButton onClick={handleClosePatientModal} sx={{ color: "white" }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <StepperHorizontal />
        </DialogContent>
      </Dialog>
      <Dialog open={isTermsModalOpen} onClose={() => setTermsModalOpen(false)}>
        <DialogContent>
            <PrivacyPolicyComponent />
        </DialogContent>
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
          <Button onClick={handleAcceptTerms} color="primary" variant="contained">
            {t("accept")}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default Layout;
